/**
 * <TutorResourcesPage> — l'onglet « Ressources pédagogiques » du masteur (page).
 *
 * L'ancien `TutorResources`, sans son référentiel des activités ni le fichier des énoncés (obsolète,
 * retiré le 03/11) : quatre entrées. Deux restent dans l'app — « Les 5 règles d'or » (le texte, dans
 * une feuille : `<TutorGoldenRules>`, à la place de l'affiche en image) et « Formation du tuteur »
 * (« Vidéos coaching », `<TutorCoachingVideosPage>`) ; deux sortent vers une page web, et le disent par
 * leur glyphe : la charte d'engagement, le blog. Les lignes d'une carte.
 *
 * Onglet racine : pas d'en-tête, c'est la coquille qui le pose. La même page sert en live (le
 * panneau des ressources du tuteur) ; ce qui l'y monte appartient au live, et la feuille des règles
 * s'y ouvre par-dessus, sans quitter la salle.
 */
import React from "react"

import { Icon } from "../../atoms/icons/Icon"
import { Modal } from "../../molecules/Modal"
import { SettingsSection, type SettingsSectionRow } from "../../molecules/SettingsSection"
import { TUTOR_GOLDEN_RULES_TITLE, TutorGoldenRules } from "../../organisms/TutorGoldenRules"
import { PageTemplate } from "../../templates/PageTemplate"

export type TutorResourcesPageProps = {
    /** « Les 5 règles d'or » : ouvre leur feuille. */
    onOpenGoldenRules: () => void
    /** La feuille des règles d'or est ouverte. */
    goldenRulesVisible?: boolean
    onCloseGoldenRules: () => void
    /** Le nom du champion qui prépare l'élève, que les règles d'or citent. */
    helperName: string
    onOpenTrainingVideos: () => void
    /** Les deux pages web. */
    onOpenCharter: () => void
    onOpenBlog: () => void
    testID?: string
}

/** Une colonne de lignes, pas un tableau de bord. */
const RESOURCES_WIDTH = 720

const external = <Icon name="external-link-alt" size={16} color="text-muted" />

export function TutorResourcesPage(props: TutorResourcesPageProps) {
    const {
        onOpenGoldenRules,
        goldenRulesVisible = false,
        onCloseGoldenRules,
        helperName,
        onOpenTrainingVideos,
        onOpenCharter,
        onOpenBlog,
        testID,
    } = props

    const rows: SettingsSectionRow[] = [
        { key: "golden-rules", iconName: "star", label: "Les 5 règles d'or", onPress: onOpenGoldenRules },
        { key: "training", iconName: "play", label: "Formation du tuteur", onPress: onOpenTrainingVideos },
        {
            key: "charter",
            iconName: "handshake",
            label: "La charte d'engagement",
            trailing: external,
            chevron: false,
            onPress: onOpenCharter,
        },
        {
            key: "blog",
            iconName: "book",
            label: "Le Blog de Masteur",
            trailing: external,
            chevron: false,
            onPress: onOpenBlog,
        },
    ]

    return (
        <PageTemplate testID={testID} padding="4" maxContentWidth={RESOURCES_WIDTH}>
            <SettingsSection title="Ressources du tuteur" rows={rows} />
            <Modal
                visible={goldenRulesVisible}
                onClose={onCloseGoldenRules}
                title={TUTOR_GOLDEN_RULES_TITLE}
                fullScreenOnSmall
            >
                <TutorGoldenRules helperName={helperName} />
            </Modal>
        </PageTemplate>
    )
}
